var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.04006 3.24C5.09032 2.18974 6.51477 1.59972 8.00006 1.59972C9.48535 1.59972 10.9098 2.18974 11.9601 3.24C13.0103 4.29026 13.6003 5.71471 13.6003 7.2C13.6003 8.68529 13.0103 10.1097 11.9601 11.16L8.00006 15.12L4.04006 11.16C3.51999 10.64 3.10745 10.0226 2.82599 9.34316C2.54453 8.6637 2.39966 7.93545 2.39966 7.2C2.39966 6.46455 2.54453 5.7363 2.82599 5.05684C3.10745 4.37738 3.51999 3.76002 4.04006 3.24ZM8.00006 8.8C8.42441 8.8 8.83138 8.63143 9.13143 8.33137C9.43149 8.03131 9.60006 7.62435 9.60006 7.2C9.60006 6.77566 9.43149 6.36869 9.13143 6.06863C8.83138 5.76857 8.42441 5.6 8.00006 5.6C7.57572 5.6 7.16875 5.76857 6.86869 6.06863C6.56863 6.36869 6.40006 6.77566 6.40006 7.2C6.40006 7.62435 6.56863 8.03131 6.86869 8.33137C7.16875 8.63143 7.57572 8.8 8.00006 8.8Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarker);
export default __webpack_public_path__ + "static/media/LocationMarker.4dcf25517a68e3fcf1e123364dd99f9f.svg";
export { ForwardRef as ReactComponent };